export default __webpack_public_path__ + "static/media/work1image2.c4baea66.png";